var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-search',{staticClass:"van-search",attrs:{"placeholder":"请输入搜索关键词,例如M280DW...","shape":"round","background":"#E0E0E0"},on:{"search":_vm.onSearch},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }